<template lang="jade">
  .container-fluid#test_page
    .row
      .col-xs-4
        | Online Device List
        .list(v-if="devices.length == 0")
          span no any devices
        .list(v-else v-for="d in devices" track-by='$index')
          label(v-bind:for="'mac_'+$index") {{ d.xtea ? 'XTEA ' : 'HTTPS ' }} {{ d.mac }}
          input(v-bind:id="'mac_'+$index" type="radio" style="float: right;" value="{{d.mac}}" v-model="selected")
        div chosen device:{{selected}}
        button(@click="changeType(0)") general
        button(@click="changeType(2)") matrix
        button(@click="changeType(1)") power
        button(@click="changeType(3)") mixer
        button(@click="changeType(6)") dio
        button(@click="changeType(4)") splitter
        button(@click="changeType(5)") mes
        button(@click="changeType(8)") ir
        button(@click="changeType(9)") rs232
        h2.title ----- {{ apiType }} Apis ------
        general-api(v-if="type === 0")
        power-api(v-if="type === 1")
        matrix-api(v-if="type === 2")
        mixer-api(v-if="type === 3")
        dio-api(v-if="type === 6")
        splitter-api(v-if='type === 4')
        mes-api(v-if='type === 5')
        ir-api(v-if='type === 8')
        rs232-api(v-if='type === 9')
      .col-xs-8.result
        .row
          .col-xs-6.scrolling
            h2 API  request
            pre(v-html="req")
          .col-xs-6.scrolling
            h2 API result
            pre(v-html="res")
          //- .col-xs-12
            h2 Events
              button clear
</template>

<script>
  import { call, deviceTypes } from 'src/Service'
  import { http } from 'vue'

  import generalApi from './apis/general'
  import matrixApi from './apis/matrix'
  import powerApi from './apis/power'
  import dioApi from './apis/dio'
  import mixerApi from './apis/mixer'
  import splitterApi from './apis/splitter'
  import mesApi from './apis/mes'
  import irApi from './apis/ir'
  import rs232Api from './apis/rs232'

  export default {
    components: {
      generalApi,
      matrixApi,
      powerApi,
      dioApi,
      mixerApi,
      splitterApi,
      mesApi,
      irApi,
      rs232Api
    },
    data () {
      return {
        devices: [],
        selected: '',
        type: 0,
        req: '',
        res: '',
        msg: ''
      }
    },
    computed: {
      apiType () {
        return deviceTypes[this.type] || 'general'
      }
    },
    ready () {
      console.log(this.$route.query.type)
      let type = deviceTypes.indexOf(this.$route.query.type)
      if (type > -1) {
        this.type = type
      }
      setInterval(async () => {
        let { data } = await http.get('/ajax/devlist')
        if (this.devices.length < data.length && this.selected === '') {
          this.selected = data[data.length - 1].mac
        }
        this.devices = data
      }, 500)
    },
    methods: {
      changeType (tid) {
        this.$router.replace({
          name: 'test',
          query: {
            type: deviceTypes[tid]
          }
        })
        this.type = tid
      },
      alert (type, title, content) {
        this.$dispatch('alert', {
          type: type,
          title: title,
          content: content
        })
      },
      hiLight (json) {
        json = JSON.stringify(json, undefined, 4)
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        // becauseof regexp is too complicated, so ...
        // eslint-disable-next-line
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, match => {
          let cls = 'number'
          if (/^"/.test(match)) {
            cls = /:$/.test(match) ? 'key' : 'string'
          } else if (/true|false/.test(match)) {
            cls = 'boolean'
          } else if (/null/.test(match)) {
            cls = 'null'
          }
          return `<span class="${cls}">${match}</span>`
        })
      }
    },
    events: {
      sendAPI (cmd, params = {}) {
        console.log(cmd, params)
        if (!this.selected) return console.log('no mac')
        this.req = this.hiLight({
          method: cmd,
          params
        })
        this.res = 'waiting response...'
        call(this.selected, cmd, params).then(res => {
          this.res = this.hiLight(res)
        }, err => {
          this.alert('danger', '', err)
        })
      }
    }
  }
</script>

<style lang='scss'>
  #test_page {

    pre {
      outline: 1px solid #ccc;
      padding: 5px;
      margin: 5px;
    }
    fieldset {
      border: 1px groove #ddd !important;
      padding: 5px 10px 10px 10px !important;
      margin: 0 0 10px 0 !important;
      -webkit-box-shadow:  0px 0px 0px 0px #000;
      box-shadow:  0px 0px 0px 0px #000;
    }
    legend {
      font-size: 1.2em !important;
      font-weight: bold !important;
      text-align: left !important;
      width: inherit;
      margin: 0;
      font-size: initial;
      border: 0px;
    }
    .title {
      text-align: center;
    }
    .list {
      label {
        margin-bottom: 0;
      }
      text-align: center;
      padding: 5px;
      margin: 5px;
      display: block;
      font-size: 13px;
      line-height: 1.42857143;
      color: #333;
      word-break: break-all;
      word-wrap: break-word;
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    }
    .string { color: green; }
    .number { color: darkorange; }
    .boolean { color: blue; }
    .null { color: magenta; }
    .key { color: red; }
    .left{
      float: left;
      width: 33%;
      height: 100%; /* Set your height here */
      overflow: scroll;
    }
    .right{
      float: left;
      width: 66%;
      height: 100%; /* Set your height here */
      overflow: scroll;
    }
    .wrap ,html, body {
       height: 98%;
    }
    .outline{
      outline: 1px solid #aaa;
    }
    .result{
      width: 66%;
      position: fixed;
      top: 30px;
      right: 0;
    }
    .scrolling{
      max-height: 90vh;
      overflow-x: scroll;
    }
  }
</style>



// WEBPACK FOOTER //
// test.vue?7894426d